import React from "react";
import { useParams, Link } from "react-router-dom";
import "../Css/Blog.css";


import "../Css/BlogDetails.css";


import blogData from "../data/blogData.js";




const BlogDetails = () => {
  const { slug } = useParams();
  const blog = blogData.find(b => b.slug === slug);

  if (!blog) return <h2>Blog Not Found</h2>;

  return (
    <>
      {/* HERO */}
      <section className="Blog-hero">
        <div className="Blog-overlay">
          <div className="Blog-hero-content">
            <h1>{blog.title}</h1>
            <p>
              <Link to="/">Home</Link> /{" "}
              <Link to="/blog">Blog</Link> /{" "}
              <span className="active">{blog.title}</span>
            </p>
          </div>
        </div>
      </section>

      {/* CONTENT */}
<div className="blog-details-page">
  <div className="blog-layout">

    {/* LEFT CONTENT */}
    <div className="blog-details-container">

    <h1 className="blog-details-title">{blog.title}</h1>
    <img src={blog.image} className="blog-details-image" />



    <div className="blog-details-meta">
      <span>By : {blog.author}</span>
      <span>{blog.date}</span>
    </div>

    <div
      className="blog-details-content"
      dangerouslySetInnerHTML={{ __html: blog.content }}
    />
  </div>


    {/* RIGHT SIDEBAR */}
    <aside className="blog-sidebar">

      {/* Recent Posts */}
      <div className="sidebar-card">
        <h3 className="sidebar-title">Recent Posts</h3>

        {blogData
          .sort((a, b) => new Date(b.date) - new Date(a.date))
          .slice(0, 5)
          .map((post, index) => (
            <Link
              key={index}
              to={`/blog/${post.slug}`}
              className="recent-post"
            >
              <img src={post.image} alt={post.title} />
              <div>
                <span className="recent-date">{post.date}</span>
                <h4>{post.title}</h4>
              </div>
            </Link>
          ))}
      </div>

      {/* Keywords */}
      <div className="sidebar-card">
        <h3 className="sidebar-title">Keywords</h3>

<div className="keyword-tags">

  <a
    href="https://share.google/48gfenKtQO3GvKmoi"
    target="_blank"
    rel="noopener noreferrer"
  >
    Maid Service in Mumbai
  </a>

  <a
    href="https://share.google/48gfenKtQO3GvKmoi"
    target="_blank"
    rel="noopener noreferrer"
  >
    House Maid in Mumbai
  </a>

  <a
    href="https://share.google/48gfenKtQO3GvKmoi"
    target="_blank"
    rel="noopener noreferrer"
  >
    Full Time Maid Service
  </a>

  <a
    href="https://share.google/48gfenKtQO3GvKmoi"
    target="_blank"
    rel="noopener noreferrer"
  >
    Part Time Maid Service
  </a>

  <a
    href="https://share.google/48gfenKtQO3GvKmoi"
    target="_blank"
    rel="noopener noreferrer"
  >
    Cooking Maid in Mumbai
  </a>

  <a
    href="https://share.google/48gfenKtQO3GvKmoi"
    target="_blank"
    rel="noopener noreferrer"
  >
    Baby Care Service in Mumbai
  </a>

  <a
    href="https://share.google/48gfenKtQO3GvKmoi"
    target="_blank"
    rel="noopener noreferrer"
  >
    Patient Care Service in Mumbai
  </a>

</div>

      </div>

    </aside>

  </div>

    </div>
    </>
  );
};

export default BlogDetails;
